module.exports = __webpack_public_path__ + "static/media/041-online-support-1.cd744e32.svg";